module.exports = {
      id: "crown-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#crown",
      toString: function () {
        return this.url;
      }
    }